/**
 * @vuepress
 * ---
 * title: asigned transformer
 */

import Transformer from '../transformer'

class assignTransformer extends Transformer {
  static fetch(payload) {
    return {
      'specialMonitoring': payload.special_monitoring
    }
  }
  static send(payload) {
    return {
        'special_monitoring': payload.specialMonitoring
      }
  }
}
export default assignTransformer
